import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";

export default function GlobalFooter() {
  return (
    <footer className="border-t border-border bg-card text-card-foreground">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-4 px-4 py-6 sm:px-6 lg:px-8">
        <Separator />
        <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
          <Button asChild variant="link" className="h-auto p-0 text-muted-foreground">
            <Link to="/about">About Us</Link>
          </Button>
          <Button asChild variant="link" className="h-auto p-0 text-muted-foreground">
            <Link to="/contact">Contact Us</Link>
          </Button>
          <Button asChild variant="link" className="h-auto p-0 text-muted-foreground">
            <Link to="/resources/faq">Privacy Policy</Link>
          </Button>
          <Button asChild variant="link" className="h-auto p-0 text-muted-foreground">
            <Link to="/resources/guides">Terms of Service</Link>
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">© The Third Door</p>
      </div>
    </footer>
  );
}